import { Select, SelectProps } from 'antd';
import { Panel } from './types';
import { useMutation } from '@apollo/client';
import {
  ASSIGN_PANEL_TO_PERMISSION,
  UNASSIGN_PANEL_TO_PERMISSION,
} from '../queries';
import { useState } from 'react';
import { Spinner } from '../../../components';
import {
  EDIT,
  EXPORT,
  FINALIZE,
  NO_ACCESS,
  NO_EXPORT,
  NO_FINALIZE,
  READ_ONLY,
  RISK_HUB,
} from '../../../constants';

interface PermissionSectionProps {
  panel: Panel;
  setNewPanel: (
    previous: string,
    value: any,
    panelName: string,
    panelUuid: string
  ) => void;
}

const PermissionSection = ({ panel, setNewPanel }: PermissionSectionProps) => {
  const editionOptions: SelectProps['options'] = [
    { label: EDIT, value: 'cltbe5u0c0001f9j4mj71nt37' },
    { label: READ_ONLY, value: 'cltbe5lyt0000f9j47dyjmts3' },
    { label: NO_ACCESS, value: 'cltbe683d0003f9j4rolsbv76' },
  ];

  const exportOptions: SelectProps['options'] = [
    { label: EXPORT, value: 'cltbe6f260004f9j4hgltedpz' },
    { label: NO_EXPORT, value: 'cltbe6l8a0005f9j453juczyn' },
  ];

  const FinalizeOptions: SelectProps['options'] = [
    { label: FINALIZE, value: 'cltbhjigv0000p8dzmo38em3h' },
    { label: NO_FINALIZE, value: 'cltbhlyzu0000jbvp83u4zp6r' },
  ];

  const [loading, setloading] = useState(false);
  const [error, seterror] = useState<any>();

  const onChange = (value: any) => {
    const label: string = editionOptions.find(
      (option) => option.value === value
    )?.label as string;

    setNewPanel(panel.permissions[0].uuid, value, label, panel.uuid);
    handleRolesUnAssigment(panel.permissions[0].uuid, panel.uuid, value);
  };

  const assignPermissionMutation = useMutation(ASSIGN_PANEL_TO_PERMISSION, {
    refetchQueries: ['GetRoleByUuid'],
  });

  const unassignPermissionMutation = useMutation(UNASSIGN_PANEL_TO_PERMISSION);

  const handleRolesAssignment = async (newPermission: any, panelId: string) => {
    await onRequest(
      assignPermissionMutation[0],
      {
        variables: {
          permissionUuids: [newPermission],
          panelUuid: panelId,
        },
      },
      true
    );
  };

  const handleRolesUnAssigment = async (
    permission: string,
    panelId: string,
    newPermission: string
  ) => {
    await onRequest(unassignPermissionMutation[0], {
      variables: {
        permissionUuids: [permission],
        panelUuid: panelId,
      },
    });
    handleRolesAssignment(newPermission, panelId);
  };

  const onRequest: any = async (request: any, params: object) => {
    setloading(true);
    try {
      await request(params);
    } catch (error) {
      seterror(error);
    } finally {
      setloading(false);
    }
  };
  if (loading) return <Spinner />;
  if (error) return <>Error! ${error}</>;

  const getSelectOptions = () => {
    if (panel.name.includes(FINALIZE)) {
      return FinalizeOptions;
    } else if (panel.name.includes(EXPORT)) {
      return exportOptions;
    } else {
      return panel.name.includes(RISK_HUB)
        ? editionOptions.filter((item) => item.label !== EDIT)
        : editionOptions;
    }
  };

  return (
    <section className="flex flex-col gap-3">
      <label className="font-semibold">{panel.name}</label>
      <section className="flex gap-2">
        <Select
          value={{
            label: panel.permissions[0].name,
            value: panel.permissions[0].uuid,
          }}
          options={getSelectOptions()}
          onChange={onChange}
          size="middle"
          className=" w-28"
          placeholder="Select"
        />
      </section>
    </section>
  );
};

export default PermissionSection;
